export default __webpack_public_path__ + "static/media/landing-bike-Footprint.9deb329f.jpg";